import {
  type AnimationType,
  type AnimationCategory,
  type AnimationMeta,
  ANIMATION_META,
} from '../../../../items/animation/animation-item-type';

export interface AnimationPreset {
  type: AnimationType;
  category: AnimationCategory;
}

// ANIMATION_META에서 프리셋 자동 생성 — hidden(프로그램 전용 타입)은 패널에서 제외.
export const ANIMATION_PRESETS: AnimationPreset[] = (
  Object.entries(ANIMATION_META) as [AnimationType, AnimationMeta][]
)
  .filter(([, meta]) => !meta.hidden)
  .map(([type, meta]) => ({
    type,
    category: meta.category,
  }));

// 카테고리별 프리셋 필터링
export const getPresetsByCategory = (
  category: AnimationCategory,
): AnimationPreset[] => {
  return ANIMATION_PRESETS.filter((preset) => preset.category === category);
};
